<template>
  <div class="forgot-password">
    <SignBanner result="change_password" />
    <ModalComponentBody>
      <SignTitle>
        {{ messages?.resetPassword }}
      </SignTitle>
      <SignText>
        {{ messages?.resetPasswordText }}
      </SignText>
      <form class="forgot-password-form" @submit.prevent="handlerSubmit">
        <DefEmail
          name="email"
          placeholder="Email"
          required
          :is-error="Boolean(errors && errors.forgetPasswordEmail)"
        >
          <template #error>
            {{ errors.forgetPasswordEmail }}
          </template>
        </DefEmail>
        <DefButtonPrimary type="submit">
          {{ messages?.resetPasswordBtn }}
        </DefButtonPrimary>
        <DefButtonSecondary type="button" @click="handlerOpenModal">
          {{ messages?.cancel }}
        </DefButtonSecondary>
      </form>
    </ModalComponentBody>
  </div>
</template>

<script lang="ts" setup>
import SignBanner from '@components/Cabinet/Entry/SignBanner.vue';
import ModalComponentBody from '@use/useModal/ModalComponentBody.vue';
import SignTitle from '@components/Cabinet/Entry/SignTitle.vue';
import SignText from '@components/Cabinet/Entry/SignText.vue';
import { computed } from 'vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';
import SignIn from '@components/Cabinet/Entry/SignIn/SignIn.vue';
import useModal from '@use/useModal/useModal';
import DefEmail from '@components/Def/DefEmail/DefEmail.vue';
import PasswordRecovery from '@components/Cabinet/Entry/ForgotPassword/PasswordRecovery.vue';
import Recaptcha3 from '@/utils/Recaptcha3';
import { useResultsStore } from '@/storePinia/stores/results';
import { usePersonalStore } from '@/storePinia/stores/personal';

const resultsStore = useResultsStore();
const personalStore = usePersonalStore();

const messages = computed(() => resultsStore.messages?.entry);
const errors = computed(() => personalStore.errors);
const modal = useModal();

const handlerSubmit = async (e: SubmitEvent) => {
  const formData: FormData = new FormData(e.target as HTMLFormElement);

  const token = await Recaptcha3.getSubmitToken();
  formData.append('g-recaptcha-response', token);

  const response = await personalStore.sendPasswordRecoveryCheckWordToUserEmail(formData);

  if (response.status === true) {
    modal.show(
      PasswordRecovery,
      {
        email: formData.get('email'),
        text: response.text,
      },
      {
        width: '900px',
        backgroundClose: false,
      }
    );
  }
};

const handlerOpenModal = async () => {
  modal.show(
    SignIn,
    {},
    {
      width: '900px',
      backgroundClose: false,
    }
  );
};
</script>

<style lang="scss" scoped>
.forgot-password {
  @include point-md {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.forgot-password-form {
  display: grid;
  grid-row-gap: 12px;
  :deep(.def-button-primary) {
    margin-top: 4px;
  }
}
</style>
